import T from 'Components/Helpers/translate';
import AppService from 'App/legacy/AppService';
import type { EntityTag } from 'App/services/EntityTags';

const ORDER_IMPORT_CLIENT_TAGS = ['Client.Id', 'Client.OrgNo', 'Client.Name'];

const orderCustomFieldTags = (customFieldType: 'order' | 'orderrow', prefix: string): EntityTag[] =>
	AppService.getCustomFields(customFieldType).map(cf => ({
		name: cf.name,
		tag: `${prefix}.custom_${cf.id}`,
		tagId: cf.id,
		datatype: cf.datatype
	}));

export const getOrderImportTags = (): { order: EntityTag[]; orderRow: EntityTag[] } => ({
	order: [
		{ tag: 'Order.Reference', name: T('import.order.reference'), importDesc: T('import.order.referenceDesc') },
		{ tag: 'Order.Date', name: T('import.order.date') },
		{ tag: 'Order.CloseDate', name: T('default.closeDate') },
		{ tag: 'Order.Description', name: T('default.description') },
		{ tag: 'Order.Notes', name: T('default.notes') },
		{ tag: 'Order.Stage.Name', name: T('default.stage'), importDesc: T('import.order.stageDesc') },
		{ tag: 'Order.User.Email', name: T('import.order.userEmail') },
		{ tag: 'Order.User.Name', name: T('import.order.userName') },
		{ tag: 'Order.Currency', name: T('default.currency') },
		{
			tag: 'Order.Contact.Email',
			name: T('import.order.contactEmail'),
			importDesc: T('import.order.contactDesc')
		},
		{ tag: 'Order.Contact.Name', name: T('import.order.contactName'), importDesc: T('import.order.contactDesc') },
		{ tag: 'Order.Project.Name', name: T('default.campaign') },
		...orderCustomFieldTags('order', 'Order')
	],
	orderRow: [
		{ tag: 'OrderRow.Product.ArticleNo', name: T('product.articleNo') },
		{ tag: 'OrderRow.Product.Name', name: T('tag.product.name') },
		{ tag: 'OrderRow.Quantity', name: T('default.quantity') },
		{ tag: 'OrderRow.Price', name: T('default.price') },
		{ tag: 'OrderRow.ListPrice', name: T('default.listPrice') },
		{ tag: 'OrderRow.PurchaseCost', name: T('default.purchasedAtCost') },
		...orderCustomFieldTags('orderrow', 'OrderRow')
	]
});

export const isOrderImportColumn = (field: string): boolean =>
	field.startsWith('Order.') || field.startsWith('OrderRow.') || ORDER_IMPORT_CLIENT_TAGS.includes(field);
